import { appFaceSadIcon } from './face-sad';
import { appUser01Icon } from './user-01';
import { appUsersMinusIcon } from './users-minus';
import { appUsersPlusIcon } from './users-plus';
export const usersIcons = [appFaceSadIcon, appUser01Icon, appUsersMinusIcon, appUsersPlusIcon];
